/* eslint-disable no-nested-ternary */
import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import CustomButton from './CustomButton';

const useStyles = makeStyles({
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    background: 'white',
    padding: '10px',
    zIndex: 10,
  },
});

const CustomPopupFooter = ({
  add = true,
  step,
  backBtn,
  saveContest,
  onClose,
  totalSteps = 3,
  disableSave = false,
}) => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="space-between" alignItems="center" className={classes.stickyFooter}>
      <Grid item>
        {step > 1 && (
          <CustomButton
            label="Back"
            variant="contained"
            size="small"
            type="secondary"
            onClick={backBtn}
            disabled={step === 1}
          />
        )}
      </Grid>

      <Grid item>
        <Grid container spacing={1}>
          <Grid item>
            <CustomButton label="Cancel" variant="contained" size="small" type="secondary" onClick={onClose} />
          </Grid>
          <Grid item>
            <CustomButton
              label={step !== totalSteps ? 'Next' : add ? 'Save' : 'Update'}
              variant="contained"
              size="small"
              type="primary"
              onClick={saveContest}
              disabled={disableSave}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CustomPopupFooter;
